<div id="duplicate-nodes" class="m-3">
    <h3>Duplicar nodos</h3>

    <div id="node-type" class="mt-3">
        <p><b>¿Qué se va a duplicar?</b></p>
        
        <label class="d-block" for="node-type-course">
            <input type="radio" id="node-type-course" class="me-2" value="course" [(ngModel)]="type" (ngModelChange)="updateSource(type)">
            <span>Curso</span>
        </label>
    
        <label class="d-block" for="node-type-unit">
            <input type="radio" id="node-type-unit" class="me-2" value="unit" [(ngModel)]="type" (ngModelChange)="updateSource(type)">
            <span>Unidad</span>
        </label>

        <label class="d-block" for="node-type-lesson">
            <input type="radio" id="node-type-lesson" class="me-2" value="lesson" [(ngModel)]="type" (ngModelChange)="updateSource(type)">
            <span>Lección</span>
        </label>
    </div>

    <hr>

    <div id="node-source" class="mt-3">
        <label class="d-block" for="node-source-category">
            <p><b>Categoría:</b></p>
            <select id="node-source-category" class="form-control" [(ngModel)]="sourceCategory" (ngModelChange)="updateSource('category')">
                <option *ngFor="let category of sourceCategories" [value]="category.id">
                    {{ category.name }}
                </option>
            </select>
        </label>
        <label class="d-block" for="node-source-course">
            <p><b>Curso:</b></p>
            <select id="node-source-course" class="form-control" [(ngModel)]="sourceCourse" (ngModelChange)="updateSource('course')">
                <option selected disabled [value]="-1">Seleccione...</option>
                <option *ngFor="let course of sourceCourses" [value]="course.id">
                    {{ course.name }}
                </option>
            </select>
        </label>
        <label class="d-block" for="node-source-unit" *ngIf="type == 'unit' || type == 'lesson'">
            <p><b>Unidad:</b></p>
            <select id="node-source-unit" class="form-control" [(ngModel)]="sourceUnit" (ngModelChange)="updateSource('unit')">
                <option selected disabled [value]="-1">Seleccione...</option>
                <option *ngFor="let unit of sourceUnits" [value]="unit.id">
                    {{ unit.name }}
                </option>
            </select>
        </label>
        <label class="d-block" for="node-source-lesson" *ngIf="type == 'lesson'">
            <p><b>Lección:</b></p>
            <select id="node-source-lesson" class="form-control" [(ngModel)]="sourceLesson" (ngModelChange)="updateSource('lesson')">
                <option selected disabled [value]="-1">Seleccione...</option>
                <option *ngFor="let lesson of sourceLessons" [value]="lesson.id">
                    {{ lesson.name }}
                </option>
            </select>
        </label>

        <hr>
    </div>
    
    <div id="node-name" *ngIf="showDestination">
        <div id="node-current-name" *ngIf="name != ''">
            <p><b>Elemento a duplicar:</b></p>
            <p>{{ name }}</p>
        </div>
    
        <div id="node-duplicate-name" class="mt-3" *ngIf="duplicateName != ''">
            <p><b>Nombre alterno:</b></p>
            <input type="text" class="form-control" [(ngModel)]="duplicateName">
        </div>
    
        <hr>
    </div>

    <div id="node-destination-div" class="mt-3" *ngIf="showDestination">
        <p><b>Destino:</b></p>
        <label class="d-block" for="node-destination-category">
            <p><b>Categoría:</b></p>
            <select id="node-destination-category" class="form-control" [(ngModel)]="destinationCategory" (ngModelChange)="updateDestination('category')">
                <option selected disabled [value]="-1">Seleccione...</option>
                <option *ngFor="let category of destinationCategories" [value]="category.id">
                    {{ category.name }}
                </option>
            </select>
        </label>
        <label class="d-block" for="node-destination-course" *ngIf="type == 'unit' || type == 'lesson'">
            <p><b>Curso:</b></p>
            <select id="node-destination-course" class="form-control" [(ngModel)]="destinationCourse" (ngModelChange)="updateDestination('course')">
                <option selected disabled [value]="-1">Seleccione...</option>
                <option *ngFor="let course of destinationCourses" [value]="course.id">
                    {{ course.name }}
                </option>
            </select>
        </label>
        <label class="d-block" for="node-destination-unit" *ngIf="type == 'lesson'">
            <p><b>Unidad:</b></p>
            <select id="node-destination-unit" class="form-control" [(ngModel)]="destinationUnit" (ngModelChange)="updateDestination('unit')">
                <option selected disabled [value]="-1">Seleccione...</option>
                <option *ngFor="let unit of destinationUnits" [value]="unit.id">
                    {{ unit.name }}
                </option>
            </select>
        </label>

        <hr>
    </div>
    
    <div id="duplicate-node-buttons" class="mt-4">
        <button class="btn btn-success me-3" [attr.disabled]="duplicating ? 'disabled' : null" (click)="duplicateNode()">
            <i class="fa fa-copy"></i>
            <span *ngIf="type == 'course'">Duplicar curso</span>
            <span *ngIf="type == 'unit'">Duplicar unidad</span>
            <span *ngIf="type == 'lesson'">Duplicar lección</span>
        </button>
        <button class="btn btn-danger me-3">
            <i class="fa fa-times"></i>
            <span>Cancelar</span>
        </button>
    </div>

    <div id="duplicate-node-status" class="mt-3">
        <div id="duplicate-node-spinner" *ngIf="duplicating">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="duplicate-node-error" class="text-danger" *ngIf="duplicateError">
            <i class="fa fa-times"></i>
            <span>Hubo un problema, no se pudo duplicar el curso. Por favor, inténtelo de nuevo.</span>
        </div>
        <div id="duplicate-node-success" class="text-success" *ngIf="duplicateSuccess">
            <i class="fa fa-check"></i>
            <span *ngIf="type == 'course'">Se ha duplicado el curso exitosamente.</span>
            <span *ngIf="type == 'unit'">Se ha duplicado la unidad exitosamente.</span>
            <span *ngIf="type == 'lesson'">Se ha duplicado la lección exitosamente.</span>
            <p><a href="/course/{{ destinationCourse }}">Ir al curso</a></p>
        </div>
    </div>
</div>